////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div>
    <span class="login-form-title">{{i18n.login.forgotPassword}}</span>
    <span class="login-form-text">{{i18n.login.forgotPasswordText}}</span>
    <Form ref="loginData" :model="loginData" :rules="loginDataRules">
        <Form-item prop="email">
            <Input type="text" v-model="loginData.email" :placeholder="i18n.login.email" icon="ios-email" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" class="login-form-button no-circle" long @click="submitOnClick()">{{i18n.login.forgotPasswordButtonText}}</Button>
          <Row class="login-form-links-group">
              <Col span="24" class="text-align-center"><router-link to="/welcome">{{i18n.backToMain}}</router-link></Col>
          </Row>
      </Form-item>
    </Form>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      loginData: {
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'i18n'
    ]),
    loginDataRules: function () {
      return {
        email: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' },
          { type: 'email', message: this.i18n.login.validations.fieldIsNotEmail, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitOnClick () {
      this.$message(JSON.stringify(this.loginData, 2))

      this.$refs['loginData'].validate((valid) => {
        if (valid) {
          this.$Message.success('удача')
        } else {
          this.$Message.error('ошибка')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ForgotPassword.vue?f5e12088